module.exports = __webpack_public_path__ + "img/sec_05.1268d197.png";